// @ts-nocheck

import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { useAuth0Login } from 'modules/useAuth0Login'
import { prepareAuth0Redirect } from 'modules/landingUrl'

export const SignUpButton = ({ saveAppState, email, redirectUri, initialUrlParams = {} }) => {
  const { loginWithRedirect, loginWithPopup } = useAuth0Login()
  const options = {
    authorizationParams: {
      screen_hint: "signup",
      login_hint: email || undefined,
      redirect_uri: redirectUri,
    },
  }
  return (
    <Dropdown.Item
      eventKey={'signup'}
      onClick={async () => {
        prepareAuth0Redirect(initialUrlParams)
        saveAppState()
        if (window.top !== window) {
          window.open(`${location.protocol}//${location.host}/signup?${email ? `email=${email}` : ''}`, '_blank')
          return
        }
        await loginWithRedirect(options)
      }}
    >
      Sign Up
    </Dropdown.Item>
  )
}